import { render, staticRenderFns } from "./public-quiz-category.html?vue&type=template&id=0b8c057f&scoped=true&"
import script from "./public-quiz-category.js?vue&type=script&lang=js&"
export * from "./public-quiz-category.js?vue&type=script&lang=js&"
import style0 from "./public-quiz-category.scss?vue&type=style&index=0&id=0b8c057f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8c057f",
  null
  
)

export default component.exports